import { render, staticRenderFns } from "./loan-penalty-settings.vue?vue&type=template&id=7f0a56b6"
import script from "./loan-penalty-settings.vue?vue&type=script&lang=js"
export * from "./loan-penalty-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../AppData/Roaming/nvm/v12.14.1/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports